import React from 'react'
import { PickingDetail } from '../../../interfaces/Picking/Picking'
import {
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableRow,
  Paper,
  TableHead
} from '@mui/material'

interface PickingSkuDetailProps {
  pickingDetailList: PickingDetail[]
}

export const PickingSkuDetail: React.FC<PickingSkuDetailProps> = ({
  pickingDetailList = []
}) => {
  return (
    <TableContainer component={Paper}>
      <Table size='small' aria-label='a dense table'>
        <TableHead>
          <TableRow>
            <TableCell style={{ padding: '0px 2px' }}>Posición</TableCell>
            <TableCell style={{ padding: '0px 2px' }} align='center'>
              SKU
            </TableCell>
            <TableCell style={{ padding: '0px 2px' }} align='center'>
              Lote
            </TableCell>
            <TableCell style={{ padding: '0px 2px' }} align='center'>
              Qty.
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {pickingDetailList.map((item) => (
            <TableRow key='sku'>
              <TableCell style={{ padding: '0px 2px' }}>
                {item.position}
              </TableCell>
              <TableCell style={{ padding: '0px 2px' }} align='center'>
                {item.sku}
              </TableCell>
              <TableCell style={{ padding: '0px 2px' }} align='center'>
                {item.batch}
              </TableCell>
              <TableCell style={{ padding: '0px 2px' }} align='center'>
                {item.qty}u
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
